import {
    Box,
    Button,
    Dialog,
    Drawer,
    IconButton,
    InputAdornment,
    TextField,
    Theme,
    Typography,
    useTheme
} from "@mui/material";
import {
    useEffect,
    useState
} from "react";
import useQuery from "../../../../utils/useQuery";
import { useHistory } from "react-router";
import {
    CrossIcon,
    DialogCloseIcon,
    FilterIcon,
    InfoIconOutlined,
    SearchIcon,
    SuccessIcon
} from "../../../../assets/SvgIcons";
import CustomFilter from "../../common/CustomFilter";
import {
    AmcFilter,
    AppliedSystematicPlansFilter,
    CancelStpTransactionResponseBody,
    CancelSwpTransactionResponseBody,
    GetSystematicPlansTableDataResponseBody,
    PauseSipTransactionResponseBody,
    // FoliosFilter,
    StatusFilter
} from "../../../../redux-store/types/investorProfile";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import {
    cancelStpTransaction,
    cancelSwpTransaction,
    getAmcFilters,
    getSystematicPlansStatusFilter,
    getSystematicPlansTableData,
    pauseSipTransaction,
    renewedCancelStpTransaction,
    setAppliedSystematicPlansFilters,
    setSystematicPlansSearchText
} from "../../../../redux-store/actions/investorProfile";
import { useDebounce } from "../../../../utils/useDebounce";
import { whiteSpaceOnlyRegex } from "../../../../utils/regex";
import {
    Order,
    PaginationObj,
    SortingObj,
    TableHeaderData
} from "../../types";
import CustomTable from "../../common/customTable";
import SystematicPlansTable, { MobileResponsiveSystematicPlans } from "./SystematicPlansTable";
import {
    ConfirmationDialog,
    ErrorDialog,
    SuccessDialog
} from "./CommonDialogs";
import PauseSipFormDialog from "./PauseSipFormDialog";
import { INV_MAND_SWITCH, MPOWER_ACCOUNT_TYPE_MASTER, NO_DATA_AVAILABLE, RM_MAND_SWITCH, USER_ROLES } from "../../../../utils/constant";
import { generateOtp, resendOtp, validateOtp } from "../../../../redux-store/actions/cart";
import { GenerateOtpResponseBody, ResendOtpResponseBody, ValidateOtpResponseBody } from "../../../../redux-store/types/cart";
import { showError } from "../../../../redux-store/actions/auth";
import SwitchMandate from "./SwitchMandate";
import OTPForm from "../../../../lib/formik/OtpForm";
import { submitInvestmentDetails } from "../../../../redux-store/actions/funds";
import { isRMLikeRole } from "../../../../utils/utilityFunctions";


// const mockFoliosFilterData = [
//     {
//         folioId: 1,
//         folioValue: "98765431123"
//     },
//     {
//         folioId: 2,
//         folioValue: "98765431123"
//     },
//     {
//         folioId: 3,
//         folioValue: "98765431123"
//     }
// ]

const initialTabItems = [
    { label: 'SIP', count: 0 },
    { label: 'STP', count: 0 },
    { label: 'SWP', count: 0 }
]

const tableHeaderData: TableHeaderData[] = [
    {
        id: 'scheme',
        label: 'Scheme Name (Folio No.)',
        align: 'left',
        isSortable: false,
    },
    {
        id: 'mandateId',
        label: 'MANDATE ID',
        align: 'center',
        isSortable: false,
    },
     {
        id: 'registrationNo',
        label: 'SIP Reg No.',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'installmentAmount',
        label: 'INSTALMENT VALUE',
        align: 'center',
        isSortable: true,
    },
     {
        id: 'investedValue',
        label: 'INVESTED AMOUNT *',
        align: 'center',
        isSortable: true,
    },
    // {
    //     id: 'instalmentNo',
    //     label: 'INSTALMENT NO',
    //     align: 'center',
    //     isSortable: true,
    // },
     {
        id:'registrationDate',
        label:'REGISTRATION DATE / START DATE',
        align:'center',
        isSortable:false,
    },
    {
        id:'nextSipDate',
        label: 'NEXT SIP DATE / END DATE',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'activeInactive',
        label: 'STATUS',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'transactionMode',
        label: 'Transaction Mode',
        align: 'center',
        isSortable: false,
    },
    {
        id: 'action',
        label: 'ACTION',
        align: 'center',
        isSortable: false,
    },
]


const getTableHeaderData = (activeTab: string): TableHeaderData[] => {
    const regNoLabel =  activeTab === 'STP' ? 'STP Reg No.' :  activeTab === 'SWP' ? 'SWP Reg No.' : 'SIP Reg No.'

    const nextDateLabel =  activeTab === 'STP' ? 'NEXT STP DATE / END DATE' :  activeTab === 'SWP' ? 'NEXT SWP DATE / END DATE' : 'NEXT SIP DATE / END DATE'

    const investedValue =  activeTab == 'STP' ? 'TRANSFERRED AMOUNT *' : activeTab == 'SWP' ? 'WITHDRAWN AMOUNT *' : 'INVESTED AMOUNT *'

    return tableHeaderData
        .filter((column) => !((activeTab === 'STP' || activeTab === 'SWP') && column.id === 'mandateId'))
        .map((column) => {
            switch (column.id) {
                case 'registrationNo':
                    return { ...column, label: regNoLabel }
                case 'investedValue':
                    return { ...column, label: investedValue }
                case 'nextSipDate':
                    return { ...column, label: nextDateLabel }
                default:
                    return column
            }
        })
}


export default function SystematicPlans(props: { clientCode: string }): JSX.Element {
    const theme = useTheme()
    const query = useQuery()
    const dispatch = useDispatch()
    const history = useHistory();

    const {
        pathname: pathName,
    } = history.location as {
        pathname: string;
    }

    const [activeTab, setActiveTab] = useState(query.get('type') ?? "SIP")
    const [selectedPlanInfo, setSelectedPlanInfo] = useState<{ [key: string]: any }>({})
    const [isFilterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false);
    const [amcFilterData, setAmcFilterData] = useState<AmcFilter[]>([])
    // const [foliosFilterData, setFoliosFilterData] = useState<FoliosFilter[]>([])
    const [statusFilterData, setStatusFilterData] = useState<StatusFilter[]>([])
    const [isFilterLoading, setFilterLoading] = useState<boolean>(false)
    const [tabItems, setTabItems] = useState<{ label: string; count: number; }[]>(initialTabItems)
    const [activeRowAmount, setActiveRowAmount] = useState<number | string>('');
    const [activeRowMandId, setActiveRowMandId] = useState<string>('');
    const [selectedMandateId, setSelectedMandateId] = useState<string>(activeRowMandId ?? '');
    const [mandateSwitchLoader, setMandateSwitchLoader] = useState<boolean>(false);
    const [tableData, setTableData] = useState<{
        isSuccess: boolean;
        data: { [key: string]: any }[]
    }>({
        isSuccess: true,
        data: []
    })
    const [isTableDataLoading, setTableDataLoading] = useState<boolean>(false)
    const [tableSortingObj, setTableSortingObj] = useState<SortingObj>({
        order: "asc",
        orderBy: "installmentAmount"
    })
    const [tablePaginationObj, setTablePaginationObj] = useState<PaginationObj>({
        currentPage: 0,
        rowsPerPage: 5,
        totalRows: 0
    })
    const [pauseSipFormData, setPauseSipFormData] = useState<{
        noOfInstallments: string;
    }>({
        noOfInstallments: ""
    })
    const [sipDialogStatus, setSipDialogStatus] = useState<{
        isPrePauseSipConfirmationOpen: boolean;
        isPauseSipFormOpen: boolean;
        isPostPauseSipConfirmationOpen: boolean;
        isPauseSipSuccessOpen: boolean;
        isPauseSipErrorOpen: boolean;
        isCancelSipConfirmationOpen: boolean;
    }>({
        isPrePauseSipConfirmationOpen: false,
        isPauseSipFormOpen: false,
        isPostPauseSipConfirmationOpen: false,
        isPauseSipSuccessOpen: false,
        isPauseSipErrorOpen: false,
        isCancelSipConfirmationOpen: false
    })
    const [stpDialogStatus, setStpDialogStatus] = useState<{
        isCancelStpConfirmationOpen: boolean;
        isCancelStpSuccessOpen: boolean;
        isCancelStpErrorOpen: boolean;
    }>({
        isCancelStpConfirmationOpen: false,
        isCancelStpSuccessOpen: false,
        isCancelStpErrorOpen: false
    })
    const [swpDialogStatus, setSwpDialogStatus] = useState<{
        isCancelSwpConfirmationOpen: boolean;
        isCancelSwpSuccessOpen: boolean;
        isCancelSwpErrorOpen: boolean;
    }>({
        isCancelSwpConfirmationOpen: false,
        isCancelSwpSuccessOpen: false,
        isCancelSwpErrorOpen: false
    })
    const [pauseCancelResponse, setPauseCancelResponse] = useState<{ [key: string]: any }>({})
    const [isPauseCancelResponseLoading, setPauseCancelResponseLoading] = useState<boolean>(false);
    const [otpLoading, setOtpLoading] = useState<boolean>(false);
    const [otpDetails, setOtpDetails] = useState<GenerateOtpResponseBody>({} as GenerateOtpResponseBody);
    const [mandateSwitchDialog, setMandateSwitchDialog] = useState<boolean>(false);
    const [isOtpDialogOpen, setIsOtpDialogOpen] = useState<boolean>(false);
    const [mandateCreationLoading, setMandateCreationLoading] = useState<boolean>(false);
    const [isSuccessDialogOpen, setSuccessDialogOpen] = useState<boolean>(false)
    const [otpData, setOtpData] = useState<any>({})


    const { role = '' } = useSelector((store: RootStateType) => store.auth);
    const {
        iwappRmId = "",
        investorClientId = "", viewAsFamilyId = "", clientInterfaceCode
    } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)
    const {
        systematicPlansSearchText = "",
        appliedSystematicPlansFilters = []
    } = useSelector((store: RootStateType) => store.investorProfile);
    const { selectedPortfolio, selectedPortfolioObj } = useSelector((state: RootStateType) => state.selectedPortfiolio)

    const debounceSearchText = useDebounce(systematicPlansSearchText, 500);

    const getAmcFilterData = async () => {
        const appliedAmcFilters = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "amc")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.companyId ?? ""}`)

        const response = await (dispatch(getAmcFilters()) as unknown as Promise<AmcFilter[]>)

        setAmcFilterData((response ?? [])?.map(obj => ({
            companyId: `${obj?.companyId ?? ""}`,
            companyName: `${obj?.companyName ?? ""}`,
            checked: appliedAmcFilters.includes(`${obj?.companyId ?? ""}`)
        })) ?? [])
    }

    // const getFoliosFilterData = () => {
    //     const appliedFoliosFilters = appliedSystematicPlansFilters
    //         .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "folios")
    //         .map((obj: AppliedSystematicPlansFilter) => `${obj?.folioId ?? ""}`)

    //     setFoliosFilterData(mockFoliosFilterData?.map(obj => ({
    //         folioId: `${obj?.folioId ?? ""}`,
    //         folioValue: `${obj?.folioValue ?? ""}`,
    //         checked: appliedFoliosFilters.includes(`${obj?.folioId ?? ""}`)
    //     })) ?? [])
    // }

    const getStatusFilterData = async () => {
        const appliedStatusFilters = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        const response = await (dispatch(getSystematicPlansStatusFilter()) as unknown as Promise<{
            code: string;
            description: string;
        }[]>)

        setStatusFilterData(response?.map(obj => ({
            statusId: `${obj?.code ?? ""}`,
            statusValue: `${obj?.description ?? ""}`,
            checked: appliedStatusFilters.includes(`${obj?.code ?? ""}`)
        })) ?? [])
    }

    const isFamilyView = pathName.includes('investor-family') && clientInterfaceCode !== viewAsFamilyId

    const fetchTableData = async ({
        currentTransactionType,
        appliedStatusFilter,
        appliedAmcFilter,
        appliedFolioNumberFilter,
        searchText,
        sortOrder,
        sortItem,
        limit,
        currentPage
    }: {
        currentTransactionType: string;
        appliedStatusFilter: string[];
        appliedAmcFilter: string[];
        appliedFolioNumberFilter?: string[] | null;
        searchText: string;
        sortOrder: string;
        sortItem: string;
        limit: number
        currentPage: number
    }) => {
        try {
            setTableDataLoading(true)

            let modifiedSearchText = ""

            if (searchText?.trim()?.length >= 5) {
                modifiedSearchText = searchText?.trim() ?? ""
            }

            const payload = {
                rmId: `${investorRmId}`,
                clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : isFamilyView ? viewAsFamilyId : investorClientId,
                portfolioId: selectedPortfolio?.value ?? "",
                transactionType: currentTransactionType,
                status: appliedStatusFilter,
                amc: appliedAmcFilter,
                folioNumber: [], // Will be changed when API is provided
                search: modifiedSearchText,
                sortOrder: sortOrder?.toUpperCase() ?? "",
                sortItem,
                limit,
                current_page: currentPage
            }

            const {
                isSuccess,
                result = [],
                message = "",
                total = 0,
                xsip_count = 0,
                swp_count = 0,
                stp_count = 0
            } = await (dispatch(getSystematicPlansTableData(payload)) as unknown as Promise<GetSystematicPlansTableDataResponseBody>)

            if (isSuccess) {
                setTableData({
                    isSuccess: true,
                    data: result
                })
                setTablePaginationObj(prevState => ({
                    ...prevState,
                    totalRows: total
                }))
                setTabItems(prevState => prevState.map(obj => {
                    if (obj.label === "SIP") return { ...obj, count: xsip_count ?? 0 }
                    if (obj.label === "STP") return { ...obj, count: stp_count ?? 0 }
                    if (obj.label === "SWP") return { ...obj, count: swp_count ?? 0 }
                    return obj
                }))
            } else {
                setTableData({
                    isSuccess: false,
                    data: []
                })
                setTablePaginationObj({
                    currentPage: 0,
                    rowsPerPage: 5,
                    totalRows: 0
                })
                setTabItems(initialTabItems)
            }

        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setTableDataLoading(false)
        }

    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setFilterLoading(true)

                await Promise.allSettled([
                    getAmcFilterData(),
                    // getFoliosFilterData(),
                    getStatusFilterData()
                ])
            } catch (error) {
                console.log((error as Error)?.message);
            } finally {
                setFilterLoading(false)
            }
        }

        fetchData()
    }, [])

    const fetchData = async () => {
        if ((
            debounceSearchText?.trim()?.length === 0 ||
            debounceSearchText?.trim()?.length >= 5) &&
            !whiteSpaceOnlyRegex?.test(debounceSearchText)
        ) {
            const appliedAmcFilter = appliedSystematicPlansFilters
                .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
                .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

            const appliedStatusFilter = appliedSystematicPlansFilters
                .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
                .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

            await fetchTableData({
                currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
                appliedStatusFilter: appliedStatusFilter ?? [],
                appliedAmcFilter: appliedAmcFilter ?? [],
                appliedFolioNumberFilter: null,
                searchText: debounceSearchText?.trim() ?? "",
                sortOrder: tableSortingObj.order.toUpperCase(),
                sortItem: tableSortingObj.orderBy,
                limit: tablePaginationObj.rowsPerPage,
                currentPage: tablePaginationObj.currentPage + 1
            })
        }
    }

    useEffect(() => {
        fetchData()
    }, [debounceSearchText])



    const handleTabChange = async (selectedTab: string) => {
        if (selectedTab === activeTab) return

        setActiveTab(selectedTab)
        setSelectedPlanInfo({})
        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        history.replace({
            pathname: location.pathname,
            search: `?tab=Systematic Plans&type=${selectedTab}`,
            state: { clientCode: props?.clientCode ?? "" }
        })

        const appliedAmcFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

        const appliedStatusFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        await fetchTableData({
            currentTransactionType: selectedTab === "SIP" ? "XSIP" : selectedTab,
            appliedStatusFilter: appliedStatusFilter ?? [],
            appliedAmcFilter: appliedAmcFilter ?? [],
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: tableSortingObj.order.toUpperCase(),
            sortItem: tableSortingObj.orderBy,
            limit: tablePaginationObj.rowsPerPage,
            currentPage: 1
        })

    }

    const handleOpenFilterDrawer = () => {
        const appliedAmcFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

        const appliedStatusFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        setAmcFilterData((prevState: AmcFilter[]) => prevState.map((obj: AmcFilter) => ({
            ...obj,
            checked: appliedAmcFilter.includes(`${obj.companyId}`)
        })))

        setStatusFilterData((prevState: StatusFilter[]) => prevState.map((obj: StatusFilter) => ({
            ...obj,
            checked: appliedStatusFilter.includes(`${obj.statusId}`)
        })))

        setFilterDrawerOpen(true)
    }

    const handleCloseFilterDrawer = () => {
        setFilterDrawerOpen(false)
    }

    const handleFilterClearAll = async () => {
        setAmcFilterData(prevState => prevState.map(item => ({ ...item, checked: false })))
        // setFoliosFilterData(prevState => prevState.map(item => ({ ...item, checked: false })))
        setStatusFilterData(prevState => prevState.map(item => ({ ...item, checked: false })))

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        if (appliedSystematicPlansFilters.length) {
            await fetchTableData({
                currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
                appliedStatusFilter: [],
                appliedAmcFilter: [],
                appliedFolioNumberFilter: null,
                searchText: systematicPlansSearchText?.trim() ?? "",
                sortOrder: tableSortingObj.order.toUpperCase(),
                sortItem: tableSortingObj.orderBy,
                limit: tablePaginationObj.rowsPerPage,
                currentPage: 1
            })
        }

        dispatch(setAppliedSystematicPlansFilters([]))
    }

    const handleApplyFilters = async () => {
        setFilterDrawerOpen(false)

        const appliedAmcFilters = amcFilterData
            ?.filter(obj => obj.checked)
            ?.map(obj => ({
                label: obj?.companyName ?? "",
                value: obj?.companyId ?? "",
                filterType: "amc",
                filterTypeValue: `amc-${obj?.companyId ?? ""}`,
                companyId: obj?.companyId ?? "",
                companyName: obj?.companyName ?? ""
            })) ?? []

        // const appliedFoliosFilters = foliosFilterData
        //     ?.filter(obj => obj.checked)
        //     ?.map(obj => ({
        //         label: obj?.folioValue ?? "",
        //         value: obj?.folioId ?? "",
        //         filterType: "folios",
        //         filterTypeValue: `folios-${obj?.folioId ?? ""}`,
        //         folioId: obj?.folioId ?? "",
        //         folioValue: obj?.folioValue ?? ""
        //     })) ?? []

        const appliedStatusFilters = statusFilterData
            ?.filter(obj => obj.checked)
            ?.map(obj => ({
                label: obj?.statusValue ?? "",
                value: obj?.statusId ?? "",
                filterType: "status",
                filterTypeValue: `status-${obj?.statusId ?? ""}`,
                statusId: obj?.statusId ?? "",
                statusValue: obj?.statusValue ?? ""
            })) ?? []

        // dispatch(setAppliedSystematicPlansFilters([...appliedAmcFilters, ...appliedFoliosFilters, ...appliedStatusFilters]))
        dispatch(setAppliedSystematicPlansFilters([...appliedAmcFilters, ...appliedStatusFilters]))

        const amcFiltersPayload = appliedAmcFilters
            .map(obj => `${obj?.companyId ?? ""}`)

        // const foliosFiltersPayload = appliedFoliosFilters
        //     .map(obj => `${obj?.folioId ?? ""}`)

        const statusFiltersPayload = appliedStatusFilters
            .map(obj => `${obj.statusId}`)

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        await fetchTableData({
            currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
            appliedStatusFilter: statusFiltersPayload,
            appliedAmcFilter: amcFiltersPayload,
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: tableSortingObj.order.toUpperCase(),
            sortItem: tableSortingObj.orderBy,
            limit: tablePaginationObj.rowsPerPage,
            currentPage: 1
        })

    }

    const handleAmcFilterChange = (value: string, checked: boolean) => {
        setAmcFilterData(prevState => prevState.map(
            item => item.companyId === value ? { ...item, checked } : item)
        )
    }

    // const handleFoliosFilterChange = (value: string, checked: boolean) => {
    //     setFoliosFilterData(prevState => prevState.map(
    //         item => item.folioId === value ? { ...item, checked } : item)
    //     )
    // }

    const handleStatusFilterChange = (value: string, checked: boolean) => {
        setStatusFilterData(prevState => prevState.map(
            item => item.statusId === value ? { ...item, checked } : item)
        )
    }

    const handleClearSearch = (e: React.MouseEvent<HTMLButtonElement>) => {
        setTableDataLoading(true)
        dispatch(setSystematicPlansSearchText(""))
        e.preventDefault()
    }

    const handleSearchTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setSystematicPlansSearchText(event.target.value))
    }

    const handleFilterLeavesClick = async (
        currentFilterType: string,
        currentFilterTypeValue: string,
        currentValue: string
    ) => {
        //Filtering out the selected filter from the appliedSystematicPlansFilters array 
        const modifiedAppliedSystematicPlansFilters = (appliedSystematicPlansFilters ?? []).filter(obj => obj?.filterTypeValue !== currentFilterTypeValue)

        dispatch(setAppliedSystematicPlansFilters(modifiedAppliedSystematicPlansFilters))

        setAmcFilterData(prevState => prevState.map(
            (obj: AmcFilter) => (currentFilterType === "amc" && obj?.companyId === currentValue) ?
                { ...obj, checked: false } : obj
        ))

        // setFoliosFilterData(prevState => prevState.map(
        //     (obj: FoliosFilter) => (currentFilterType === "folios" && obj?.folioId === currentValue) ?
        //         { ...obj, checked: false } : obj
        // ))

        setStatusFilterData(prevState => prevState.map(
            (obj: StatusFilter) => currentFilterType === "status" && obj.statusId === currentValue ? { ...obj, checked: false } : obj
        ))

        const amcFiltersPayload = modifiedAppliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.companyId ?? ""}`)

        // const foliosFiltersPayload = modifiedAppliedSystematicPlansFilters
        //     .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === 'folios')
        //     .map((obj: AppliedSystematicPlansFilter) => `${obj?.folioId ?? ""}`)

        const statusFiltersPayload = modifiedAppliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === 'status')
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        setTablePaginationObj(prevState => ({ ...prevState, currentPage: 0 }))

        await fetchTableData({
            currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
            appliedStatusFilter: statusFiltersPayload ?? [],
            appliedAmcFilter: amcFiltersPayload ?? [],
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: tableSortingObj.order.toUpperCase(),
            sortItem: tableSortingObj.orderBy,
            limit: tablePaginationObj.rowsPerPage,
            currentPage: 1
        })
    }

    const handleTableSort = async (orderBy: string, order: Order) => {
        setTableSortingObj({
            order,
            orderBy
        })

        const appliedAmcFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

        const appliedStatusFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        await fetchTableData({
            currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
            appliedStatusFilter: appliedStatusFilter ?? [],
            appliedAmcFilter: appliedAmcFilter ?? [],
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: order.toUpperCase(),
            sortItem: orderBy,
            limit: tablePaginationObj.rowsPerPage,
            currentPage: tablePaginationObj.currentPage + 1
        })
    }

    const handleTableRowsPerPageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            rowsPerPage: Number(event.target.value),
            currentPage: 0,
        }))

        const appliedAmcFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

        const appliedStatusFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        await fetchTableData({
            currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
            appliedStatusFilter: appliedStatusFilter ?? [],
            appliedAmcFilter: appliedAmcFilter ?? [],
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: tableSortingObj.order.toUpperCase(),
            sortItem: tableSortingObj.orderBy,
            limit: Number(event.target.value),
            currentPage: 1
        })
    }

    const handleTablePageChange = async (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        setTablePaginationObj(prevState => ({
            ...prevState,
            currentPage: page
        }))

        const appliedAmcFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj.filterType.toLowerCase() === 'amc')
            .map((obj: AppliedSystematicPlansFilter) => `${obj.companyId}`)

        const appliedStatusFilter = appliedSystematicPlansFilters
            .filter((obj: AppliedSystematicPlansFilter) => obj?.filterType?.toLowerCase() === "status")
            .map((obj: AppliedSystematicPlansFilter) => `${obj?.statusId ?? ""}`)

        await fetchTableData({
            currentTransactionType: activeTab === "SIP" ? "XSIP" : activeTab,
            appliedStatusFilter: appliedStatusFilter ?? [],
            appliedAmcFilter: appliedAmcFilter ?? [],
            appliedFolioNumberFilter: null,
            searchText: systematicPlansSearchText?.trim() ?? "",
            sortOrder: tableSortingObj.order.toUpperCase(),
            sortItem: tableSortingObj.orderBy,
            limit: tablePaginationObj.rowsPerPage,
            currentPage: page + 1
        })
    }

    const handlePauseSystematicPlan = (id: string, type: string) => {
        const selectedPlanObj = tableData?.data?.find(obj => obj?.registrationNo === id) ?? {}

        setSelectedPlanInfo({ ...selectedPlanObj, activeTransactionType: type })

        if (type === "SIP") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isPrePauseSipConfirmationOpen: true
            }))
        }
    }

    const handleCancelSystematicPlan = (id: string, type: string) => {
        const selectedPlanObj = tableData?.data?.find(obj => obj?.registrationNo === id) ?? {}

        setSelectedPlanInfo({ ...selectedPlanObj, activeTransactionType: type })

        if (type === "SIP") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isCancelSipConfirmationOpen: true
            }))
        }
        if (type === "STP") {
            setStpDialogStatus(prevState => ({
                ...prevState,
                isCancelStpConfirmationOpen: true
            }))
        }
        if (type === "SWP") {
            setSwpDialogStatus(prevState => ({
                ...prevState,
                isCancelSwpConfirmationOpen: true
            }))
        }
    }

    const handleSwitchMandate = (amount: number | string, id: string) => {
        const selectedPlanObj = tableData?.data?.find(obj => obj?.registrationNo === id) ?? {}
        setSelectedPlanInfo({ ...selectedPlanObj, activeTransactionType: 'XSIP' })
        setActiveRowAmount(amount);
        setActiveRowMandId(selectedPlanObj?.mandateId ?? '');
        setSelectedMandateId(selectedPlanObj?.mandateId ?? '');
        setMandateSwitchDialog(true);
    }

    const handleCancelBtnConfirmationDialog = ({ type, status }: { type: string; status: string; }) => {
        setSelectedPlanInfo({})

        if (type === "SIP" && status === "prePauseSip") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isPrePauseSipConfirmationOpen: false
            }))
        }
        if (type === "SIP" && status === "postPauseSip") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isPostPauseSipConfirmationOpen: false
            }))
            setPauseSipFormData({ noOfInstallments: "" })
        }
        if (type === "SIP" && status === "cancelSip") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isCancelSipConfirmationOpen: false
            }))
        }
        if (type === "STP" && status === "cancelStp") {
            setStpDialogStatus(prevState => ({
                ...prevState,
                isCancelStpConfirmationOpen: false
            }))
        }
        if (type === "SWP" && status === "cancelSwp") {
            setSwpDialogStatus(prevState => ({
                ...prevState,
                isCancelSwpConfirmationOpen: false
            }))
        }

    }

    const handleOtpCase = async (cartId: string, token: string) => {
        const payload = {
            order_cart_id: cartId,
            token
        }
        try {
            setOtpLoading(true);
            const response = await (dispatch(generateOtp(payload)) as unknown as Promise<GenerateOtpResponseBody>)
            setOtpDetails(response);
            if (!response?.isSuccess) return;
            history.push(`${pathName}/${selectedPlanInfo?.scheme}/otp-screen`, {
                paymentId: response?.token ?? "",
                cartId: response?.cartId ?? '',
                id: response?.id ? `${response?.id}` : "",
                message: response?.message ?? "",
            })
        } catch (e) {
            console.log('error', e);
            dispatch(showError(otpDetails?.message ?? ''))
        } finally {
            setOtpLoading(false);
        }
    }
    const handleSubmitPauseSipForm = ({ noOfInstallments }: { noOfInstallments: string }) => {
        setPauseSipFormData({
            noOfInstallments
        })

        setSipDialogStatus(prevState => ({
            ...prevState,
            isPauseSipFormOpen: false,
            isPostPauseSipConfirmationOpen: true
        }))
    }
    const handleConfirmBtnConfirmationDialog = async ({ type, status }: { type: string; status: string; }) => {
        try {
            if (type === "SIP" && status === "prePauseSip") {
                setSipDialogStatus(prevState => ({
                    ...prevState,
                    isPrePauseSipConfirmationOpen: false,
                    // isPauseSipFormOpen: true
                }))
                history.push(`${pathName}/pause-sip`, {
                    selectedPlanInfo,
                    clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
                    rmId: `${iwappRmId}`,
                    // handleSubmitPauseSipForm
                })
            }
            if (type === "SIP" && status === "postPauseSip") {
                setPauseCancelResponseLoading(true)

                const payload = {
                    clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
                    registrationType: "XSIP",
                    registrationNumber: selectedPlanInfo?.registrationNo,
                    modificationType: "PAUSE",
                    noOfInstallments: pauseSipFormData?.noOfInstallments,
                    rmId: `${investorRmId}`,
                    portfolioId: selectedPortfolio?.value,
                    amcId: selectedPlanInfo?.amcId,
                    fromSchemeName: selectedPlanInfo?.schemeName,
                    fromSchemeCode: selectedPlanInfo?.scheme,
                    isRecommended: (isRMLikeRole(role?.toLowerCase())),
                    isDiy: !(isRMLikeRole(role?.toLowerCase())),
                    folioNo: selectedPlanInfo?.folioNo
                }

                const response = await (dispatch(pauseSipTransaction(payload)) as unknown as Promise<PauseSipTransactionResponseBody>)

                setPauseSipFormData({ noOfInstallments: "" })

                if (!response) {
                    setSipDialogStatus(prevState => ({
                        ...prevState,
                        isPostPauseSipConfirmationOpen: false,
                    }))

                    setSelectedPlanInfo({})
                }
                if (response?.isSuccess && response?.isPaymentFlow) {
                    setPauseCancelResponse(response)
                    handleOtpCase(response?.cartId ?? "", response?.token ?? "")
                }
                if (response?.isSuccess && !response?.isPaymentFlow) {
                    setPauseCancelResponse(response)

                    setSipDialogStatus(prevState => ({
                        ...prevState,
                        isPostPauseSipConfirmationOpen: false,
                        isPauseSipSuccessOpen: true
                    }))
                }
                if (!response?.isSuccess) {
                    setPauseCancelResponse(response)

                    setSipDialogStatus(prevState => ({
                        ...prevState,
                        isPostPauseSipConfirmationOpen: false,
                        isPauseSipErrorOpen: true
                    }))
                }
            }
            if (type === "SIP" && status === "cancelSip") {
                history.push(`${pathName}/${selectedPlanInfo?.scheme}/reason-for-cancellation`, {
                    clientCode: props?.clientCode ?? "",
                    selectedPlanObj: selectedPlanInfo,
                    currentType: activeTab
                })

                setSipDialogStatus(prevState => ({
                    ...prevState,
                    isCancelSipConfirmationOpen: false
                }))
            }
            if (type === "STP" && status === "cancelStp") {
                history.push(`${pathName}/${selectedPlanInfo?.scheme}/reason-for-cancellation`, {
                    clientCode: props?.clientCode ?? "",
                    selectedPlanObj: selectedPlanInfo,
                    currentType: activeTab
                })
                // setPauseCancelResponseLoading(true)

                // const payload = {
                //     clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
                //     accountType: MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()],
                //     orderDetails: [
                //         {
                //             registrationNumber: selectedPlanInfo?.registrationNo,
                //             clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
                //             remarks: "",
                //             rmId: `${iwappRmId}`,
                //             portfolioId: selectedPortfolio?.value,
                //             amcId: selectedPlanInfo?.amcId,
                //             fromSchemeName: selectedPlanInfo?.schemeName,
                //             fromSchemeCode: selectedPlanInfo?.scheme,
                //             toSchemeName: selectedPlanInfo?.toSchemeName,
                //             toSchemeCode: selectedPlanInfo?.toScheme,
                //             isRecommended: (isRMLikeRole(role?.toLowerCase())),
                //             isDiy: !(isRMLikeRole(role?.toLowerCase())),
                //             folioNo: selectedPlanInfo?.folioNo,
                //             portfolioName: selectedPortfolio?.label ?? ""
                //         }
                //     ]

                // }

                // const response = await (dispatch(renewedCancelStpTransaction(payload)) as unknown as Promise<CancelStpTransactionResponseBody>)

                // if (!response) {
                //     setStpDialogStatus(prevState => ({
                //         ...prevState,
                //         isCancelStpConfirmationOpen: false,
                //     }))

                //     setSelectedPlanInfo({})
                // }
                // if (response?.isSuccess && response?.isPaymentFlow) {
                //     setPauseCancelResponse(response)
                //     handleOtpCase(response?.cartId ?? "", response?.token ?? "")
                // }
                // if (response?.isSuccess && !response?.isPaymentFlow) {
                //     setPauseCancelResponse(response)

                //     setStpDialogStatus(prevState => ({
                //         ...prevState,
                //         isCancelStpConfirmationOpen: false,
                //         isCancelStpSuccessOpen: true
                //     }))
                // }
                // if (!response.isSuccess) {
                //     setPauseCancelResponse(response)

                //     setStpDialogStatus(prevState => ({
                //         ...prevState,
                //         isCancelStpConfirmationOpen: false,
                //         isCancelStpErrorOpen: true
                //     }))
                // }
            }
            if (type === "SWP" && status === "cancelSwp") {
                setPauseCancelResponseLoading(true)

                const payload = {
                    registrationNumber: selectedPlanInfo?.registrationNo,
                    clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
                    remarks: "",
                    rmId: `${investorRmId}`,
                    portfolioId: selectedPortfolio?.value,
                    amcId: selectedPlanInfo?.amcId,
                    fromSchemeName: selectedPlanInfo?.schemeName,
                    fromSchemeCode: selectedPlanInfo?.scheme,
                    isRecommended: (isRMLikeRole(role?.toLowerCase())),
                    isDiy: !(isRMLikeRole(role?.toLowerCase()))
                }

                const response = await (dispatch(cancelSwpTransaction(payload)) as unknown as Promise<CancelSwpTransactionResponseBody>)

                if (!response) {
                    setSwpDialogStatus(prevState => ({
                        ...prevState,
                        isCancelSwpConfirmationOpen: false,
                    }))

                    setSelectedPlanInfo({})
                }
                if (response.isSuccess) {
                    setPauseCancelResponse(response)

                    setSwpDialogStatus(prevState => ({
                        ...prevState,
                        isCancelSwpConfirmationOpen: false,
                        isCancelSwpSuccessOpen: true
                    }))
                }
                if (!response.isSuccess) {
                    setPauseCancelResponse(response)

                    setSwpDialogStatus(prevState => ({
                        ...prevState,
                        isCancelSwpConfirmationOpen: false,
                        isCancelSwpErrorOpen: true
                    }))
                }
            }
        } catch (error) {
            console.log((error as Error)?.message);
        } finally {
            setPauseCancelResponseLoading(false)
        }
    }

    const handleBtnSuccessDialog = ({ type }: { type: string; }) => {
        setSelectedPlanInfo({})
        setPauseCancelResponse({})

        if (type === "SIP") {
            if ((isRMLikeRole(role?.toLowerCase()))) {
                history.push('/dashboard')
            } else {
                history.push('/investor-dashboard')
            }

            setSipDialogStatus(prevState => ({
                ...prevState,
                isPauseSipSuccessOpen: false
            }))
        }
        if (type === "STP") {
            if ((isRMLikeRole(role?.toLowerCase()))) {
                history.push('/dashboard')
            } else {
                history.push('/investor-dashboard')
            }

            setStpDialogStatus(prevState => ({
                ...prevState,
                isCancelStpSuccessOpen: false
            }))
        }
        if (type === "SWP") {
            if ((isRMLikeRole(role?.toLowerCase()))) {
                history.push('/dashboard')
            } else {
                history.push('/investor-dashboard')
            }

            setSwpDialogStatus(prevState => ({
                ...prevState,
                isCancelSwpSuccessOpen: false
            }))
        }

        dispatch(setSystematicPlansSearchText(""))
        dispatch(setAppliedSystematicPlansFilters([]))
    }

    const handleBtnErrorDialog = ({ type }: { type: string; }) => {
        setSelectedPlanInfo({})
        setPauseCancelResponse({})

        if (type === "SIP") {
            setSipDialogStatus(prevState => ({
                ...prevState,
                isPauseSipErrorOpen: false
            }))
        }
        if (type === "STP") {
            setStpDialogStatus(prevState => ({
                ...prevState,
                isCancelStpErrorOpen: false
            }))
        }
        if (type === "SWP") {
            setSwpDialogStatus(prevState => ({
                ...prevState,
                isCancelSwpErrorOpen: false
            }))
        }
    }

    const handleClosePauseSipFormDialog = () => {
        setSelectedPlanInfo({})

        setSipDialogStatus(prevState => ({
            ...prevState,
            isPauseSipFormOpen: false
        }))
    }

    const handleSwitchMandatePopup = () => {
        setMandateSwitchDialog(false);
    }

    const helperPayloadObj = {
        registrationNumber: selectedPlanInfo?.registrationNo,
        registrationType: 'XSIP',
        trType: "MANDATE_SWITCH",
        clientCode: (isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId,
        remarks: "",
        rmId: `${investorRmId}`,
        portfolioId: selectedPortfolio?.value,
        amcId: selectedPlanInfo?.amcId,
        fromSchemeName: selectedPlanInfo?.schemeName,
        fromSchemeCode: selectedPlanInfo?.scheme,
        isRecommended: (isRMLikeRole(role?.toLowerCase())),
        isDiy: !(isRMLikeRole(role?.toLowerCase())),
        folio: selectedPlanInfo?.folioNo ?? "",
        portfolioName: selectedPortfolio?.label ?? ""
    }

    const handleOtpResend = async () => {
        const payload = {
            token: otpData?.token ?? "",
            id: otpData?.otp_response?.id ?? "",
            cartId: otpData?.otp_response?.cartId ?? "",
        }

        const response = await (dispatch(resendOtp(payload)) as unknown as Promise<ResendOtpResponseBody>)

        if (response?.isSuccess) {
            setOtpData({
                ...otpData,
                token: response?.token ?? "",
                otp_response: {
                    ...otpData?.otp_response,
                    id: response?.id ?? "",
                    cartId: response?.cartId ?? "",
                    message: response?.message ?? "",
                }
            })
        }
    }

    const handleOtpSubmit = async (otp: string) => {
        const payload = {
            otp,
            token: otpData?.token ?? "",
            id: otpData?.otp_response?.id ?? "",
            cartId: otpData?.otp_response?.cartId ?? "",
        }
        try {
            const response = await (dispatch(validateOtp(payload)) as unknown as Promise<ValidateOtpResponseBody>);
            if (response?.isSuccess) {
                setIsOtpDialogOpen(false);
                setSuccessDialogOpen(true);
            }
            else {
                setIsOtpDialogOpen(false);
                dispatch(showError(response?.message ?? ""));
            }
        } catch (e) {
            console.error('Error', e);
        }
    }

    const onOtpDialogClose = () => {
        setIsOtpDialogOpen(false);
    }

    const onSuccessDialogClose = async () => {
        setSuccessDialogOpen(false)
        await fetchData()
    }

    const handleActiveMandate = async () => {
        if (activeRowMandId !== selectedMandateId) {
            try {
                setMandateSwitchLoader(true);
                const mandateRes = await (dispatch(submitInvestmentDetails({
                    accountType: 'EXY',
                    orderDetails: [{
                        ...helperPayloadObj,
                        toMandateId: selectedMandateId,
                        mandate_payload: null,
                    }]
                })) as unknown as Promise<any>);
                if (mandateRes?.isSuccess && mandateRes?.isPaymentFlow) {
                    setOtpData(mandateRes ?? {})
                    handleSwitchMandatePopup();
                    setIsOtpDialogOpen(true);
                }
            } catch (e) {
                console.warn('Error', e);
            } finally {
                setMandateSwitchLoader(false);
            }
        }
        else {
            handleSwitchMandatePopup();
        }
    }

    const handleCreateMandate = async (value: any, mandateObj: any) => {
        try {
            setMandateCreationLoading(true);
            const mandateRes = await (dispatch(submitInvestmentDetails({
                accountType: 'EXY',
                orderDetails: [{
                    ...helperPayloadObj,
                    toMandateId: null,
                    mandate_payload: mandateObj,
                }]
            })) as unknown as Promise<any>);
            if (mandateRes?.isSuccess && mandateRes?.isPaymentFlow) {
                setOtpData(mandateRes ?? {})
                handleSwitchMandatePopup();
                setIsOtpDialogOpen(true);
            }
        } catch (e) {
            console.warn('Error', e);
        } finally {
            setMandateCreationLoading(false);
        }
    };

    return (
        <>
            <Box
                sx={(theme: Theme) => ({
                    borderRadius: "25px",
                    padding: { xs: "15px", sm: "35px" },
                    backgroundColor: theme.palette.common.white
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Systematic Plans
                    </Typography>
                    <Button
                        variant="text"
                        startIcon={
                            <FilterIcon
                                style={{ opacity: (isFilterLoading || isTableDataLoading) ? 0.5 : 1 }}
                            />
                        }
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.primary,
                            padding: "5px",
                            ...theme.typography.body_500,
                            "&:hover": {
                                backgroundColor: theme.palette.grey[50]
                            }
                        })}
                        TouchRippleProps={{
                            style: {
                                color: theme.palette.grey[300]
                            }
                        }}
                        onClick={handleOpenFilterDrawer}
                        disabled={isFilterLoading || isTableDataLoading}
                    >
                        Filters
                    </Button>
                </Box>
                <Box
                    sx={{ marginTop: '20px' }}
                >
                    <Box
                        sx={(theme: Theme) => ({
                            borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '10px'
                        })}
                    >
                        {tabItems.map((
                            { label, count }: { label: string; count: number; }
                        ) => (
                            <Button
                                key={`${label}-${count}`}
                                sx={(theme: Theme) => ({
                                    padding: '5px 15px',
                                    background: activeTab === label ?
                                        theme.palette.primary[500] :
                                        theme.palette.grey[50],
                                    color: activeTab === label ?
                                        theme.palette.textDark.primary :
                                        theme.palette.text.secondary,
                                    borderRadius: "0px",
                                    borderTopLeftRadius: "7px",
                                    borderTopRightRadius: "7px",
                                    columnGap: "10px",
                                    "&:hover": {
                                        backgroundColor: activeTab === label ?
                                            theme.palette.primary[200] :
                                            `${theme.palette.grey[50]}99`,
                                        boxShadow: "none"
                                    }
                                })}
                                onClick={() => handleTabChange(label)}
                                disabled={isTableDataLoading}
                            >
                                <Typography
                                    variant="body_500"
                                    sx={{
                                        letterSpacing: '0.02px',
                                        lineHeight: '20px'
                                    }}
                                >
                                    {label}
                                </Typography>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        lineHeight: '20px',
                                        letterSpacing: '0.02px',
                                        padding: '0px 10px',
                                        backgroundColor: activeTab === label ?
                                            theme.palette.textDark.primary :
                                            theme.palette.primary[100],
                                        color: theme.palette.primary[500],
                                        borderRadius: '7px',
                                        display: 'flex',
                                        justifyContent: "center",
                                        alignItems: "center"
                                    })}
                                >
                                    {count}
                                </Typography>
                            </Button>
                        ))}
                    </Box>
                </Box>
                <Box
                    sx={{
                        marginTop: "20px",
                    }}
                >
                    <Box>
                        <TextField
                            autoFocus
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            sx={{ display: systematicPlansSearchText.length > 0 ? 'inline-flex' : 'none' }}
                                            onClick={handleClearSearch} aria-label="Clear search"
                                        >
                                            <DialogCloseIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                sx: (theme: Theme) => ({
                                    borderRadius: '8px',
                                    height: '50px',
                                    border: `1px solid ${theme.palette.text.secondary}B2`,
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '& input': {
                                        paddingLeft: '10px',
                                        ...theme.typography.body_500,
                                        color: theme.palette.text.primary,
                                        '::placeholder': {
                                            ...theme.typography.subtitle_400,
                                            color: theme.palette.text.secondary,
                                            opacity: 1,
                                        },
                                    },
                                }),
                            }}
                            value={systematicPlansSearchText}
                            placeholder="Search"
                            onChange={handleSearchTextChange}
                        />
                    </Box>
                    <Typography
                        variant="overline_600"
                        sx={(theme: Theme) => ({
                            color: theme.palette.grey[500],
                            marginTop: "5px"
                        })}
                    >
                        Minimum 5 characters required
                    </Typography>
                </Box>
                <Box
                    sx={{
                        marginTop: "25px",
                        display: (appliedSystematicPlansFilters ?? []).length ? "flex" : "none",
                        gap: "15px",
                        flexWrap: "wrap",
                    }}
                >
                    {(appliedSystematicPlansFilters ?? []).map((obj) => (
                        <Button
                            key={obj.filterTypeValue}
                            variant="contained"
                            startIcon={<CrossIcon />}
                            onClick={() => handleFilterLeavesClick(
                                obj.filterType,
                                obj.filterTypeValue,
                                obj.value
                            )}
                            sx={(theme: Theme) => ({
                                borderRadius: "61px",
                                backgroundColor: theme.palette.primary[50],
                                padding: "7px 16px",
                                color: theme.palette.text.primary,
                                whiteSpace: "nowrap",
                                boxShadow: "none",
                                ...theme.typography.subtitle_400,
                                "& .MuiButton-startIcon": {
                                    paddingTop: "2px"
                                },
                                "&:hover": {
                                    backgroundColor: theme.palette.primary[100],
                                    boxShadow: "none"
                                },
                                "&.Mui-disabled": {
                                    opacity: 0.5
                                }
                            })}
                            disabled={isTableDataLoading}
                        >
                            {obj?.label ?? ""}
                        </Button>
                    ))}
                </Box>
                <Box sx={{ marginTop: "20px" }}>
                    <CustomTable
                        isLoading={isTableDataLoading}
                        tableBody={
                            <SystematicPlansTable
                                data={tableData?.data ?? []}
                                type={activeTab}
                                handlePause={handlePauseSystematicPlan}
                                handleCancel={handleCancelSystematicPlan}
                                handleSwitchMandate={handleSwitchMandate}
                            />
                        }
                        tableHeaderData={getTableHeaderData(activeTab)}
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        tableData={tableData?.data ?? []}
                        handleSort={handleTableSort}
                        tableDataCount={tablePaginationObj.totalRows}
                        rowsPerPage={tablePaginationObj.rowsPerPage}
                        handleRowsPerPageChange={handleTableRowsPerPageChange}
                        handlePageChange={handleTablePageChange}
                        currentPage={tablePaginationObj.currentPage}
                        order={tableSortingObj.order}
                        orderBy={tableSortingObj.orderBy}
                        tableBodyLoaderRowCustomStyles={{
                            '& td:first-of-type': {
                                paddingLeft: "0px"
                            },
                        }}
                        tableHeadRowCustomStyles={{
                            '& th:first-of-type': {
                                paddingLeft: "0px"
                            }
                        }}
                        tableBodyCustomStyles={{
                            '& tr:last-child td': {
                                border: 0
                            }
                        }}
                        loadingRowsNum={5}
                        manualResponsiveBody={true}
                        hideResponsiveHeader={true}
                        ManualResponsiveBodyComponent={
                            <MobileResponsiveSystematicPlans
                                data={tableData?.data ?? []}
                                type={activeTab}
                                tableHeaderData={getTableHeaderData(activeTab)}
                                handlePause={handlePauseSystematicPlan}
                                handleCancel={handleCancelSystematicPlan}
                            />
                        }
                        noResultMsg={(
                            (debounceSearchText?.trim()?.length >= 5) ||
                            appliedSystematicPlansFilters.length > 0) ?
                            "No Result Found" :
                            NO_DATA_AVAILABLE
                        }
                    />
                </Box>
                <Box>
                    <Typography
                        variant="subtitle_500"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.primary
                        })}
                    >
                        * Amount represents the cumulative {activeTab} investment made till date
                    </Typography>
                </Box>
            </Box >
            <Drawer
                open={isFilterDrawerOpen}
                onClose={handleCloseFilterDrawer}
                anchor="right"
                PaperProps={{
                    sx: (theme: Theme) => ({
                        padding: "25px",
                        width: "450px",
                        [theme.breakpoints.down("sm")]: {
                            width: "100%",
                            maxWidth: "100%",
                        },
                    }),
                }}
                ModalProps={{
                    sx: (theme: Theme) => ({
                        backgroundColor: `${theme.palette.common.black}03`
                    })
                }}
            >
                <CustomFilter
                    isLoading={false}
                    handleClearAll={handleFilterClearAll}
                    handleApplyFilters={handleApplyFilters}
                    showCloseIcon={true}
                    handleCloseIconClick={handleCloseFilterDrawer}
                    amcFilterData={amcFilterData}
                    handleAmcFilterChange={handleAmcFilterChange}
                    // showFoliosFilter={true}
                    // foliosFilterData={foliosFilterData}
                    // handleFoliosFilterChange={handleFoliosFilterChange}
                    showStatusFilter={true}
                    statusFilterData={statusFilterData}
                    handleStatusFilterChange={handleStatusFilterChange}
                    defaultExpandedFilter="amc"
                    showCategoryFilter={false}
                    showRiskFilter={false}
                />
            </Drawer>

            {/* Pre Pause SIP Confirmation Dialog */}
            <ConfirmationDialog
                open={sipDialogStatus.isPrePauseSipConfirmationOpen}
                title="Confirm!"
                content="You are allowed to pause the SIP only twice. Would you like to proceed?"
                onCancel={() => handleCancelBtnConfirmationDialog({
                    type: "SIP",
                    status: "prePauseSip"
                })}
                onConfirm={() => handleConfirmBtnConfirmationDialog({
                    type: "SIP",
                    status: "prePauseSip"
                })}
            />
            {/* Pause SIP Form Dialog */}
            {sipDialogStatus.isPauseSipFormOpen && (
                <PauseSipFormDialog
                    open={sipDialogStatus.isPauseSipFormOpen}
                    onClose={handleClosePauseSipFormDialog}
                    handleSubmit={handleSubmitPauseSipForm}
                    selectedPlanInfo={selectedPlanInfo}
                />
            )}
            {/* Post Pause SIP Confirmation Dialog */}
            <ConfirmationDialog
                title="Confirm Pause!"
                open={sipDialogStatus.isPostPauseSipConfirmationOpen}
                onCancel={() => handleCancelBtnConfirmationDialog({
                    type: "SIP",
                    status: "postPauseSip"
                })}
                onConfirm={() => handleConfirmBtnConfirmationDialog({
                    type: "SIP",
                    status: "postPauseSip"
                })}
                isLoading={isPauseCancelResponseLoading || otpLoading}
            />
            {/* Pause SIP Success Dialog */}
            <SuccessDialog
                open={sipDialogStatus.isPauseSipSuccessOpen}
                handleClick={() => handleBtnSuccessDialog({ type: "SIP" })}
                content={pauseCancelResponse?.message ?? ""}
            />
            {/* Pause SIP Error Dialog */}
            <ErrorDialog
                open={sipDialogStatus.isPauseSipErrorOpen}
                content={pauseCancelResponse?.message ?? ""}
                handleClick={() => handleBtnErrorDialog({ type: "SIP" })}
            />
            {/* Cancel SIP Confirmation Dialog */}
            <ConfirmationDialog
                open={sipDialogStatus.isCancelSipConfirmationOpen}
                title="Confirm!"
                content="Are you sure you want to cancel the SIP registration?"
                onCancel={() => handleCancelBtnConfirmationDialog({
                    type: "SIP",
                    status: "cancelSip"
                })}
                onConfirm={() => handleConfirmBtnConfirmationDialog({
                    type: "SIP",
                    status: "cancelSip"
                })}
            />
            {/* Cancel STP Confirmation Dialog */}
            <ConfirmationDialog
                open={stpDialogStatus.isCancelStpConfirmationOpen}
                onCancel={() => handleCancelBtnConfirmationDialog({
                    type: "STP",
                    status: "cancelStp"
                })}
                onConfirm={() => handleConfirmBtnConfirmationDialog({
                    type: "STP",
                    status: "cancelStp"
                })}
                isLoading={isPauseCancelResponseLoading || otpLoading}
            />
            {/* Cancel STP Success Dialog */}
            <SuccessDialog
                open={stpDialogStatus.isCancelStpSuccessOpen}
                handleClick={() => handleBtnSuccessDialog({ type: "STP" })}
                content={pauseCancelResponse?.message ?? ""}
            />
            {/* Cancel STP Error Dialog */}
            <ErrorDialog
                open={stpDialogStatus.isCancelStpErrorOpen}
                content={pauseCancelResponse?.message ?? ""}
                handleClick={() => handleBtnErrorDialog({ type: "STP" })}
            />
            {/* Cancel SWP Confirmation Dialog */}
            <ConfirmationDialog
                open={swpDialogStatus.isCancelSwpConfirmationOpen}
                onCancel={() => handleCancelBtnConfirmationDialog({
                    type: "SWP",
                    status: "cancelSwp"
                })}
                onConfirm={() => handleConfirmBtnConfirmationDialog({
                    type: "SWP",
                    status: "cancelSwp"
                })}
                isLoading={isPauseCancelResponseLoading}
            />
            {/* Cancel SWP Success Dialog */}
            <SuccessDialog
                open={swpDialogStatus.isCancelSwpSuccessOpen}
                handleClick={() => handleBtnSuccessDialog({ type: "SWP" })}
            />
            {/* Cancel SWP Error Dialog */}
            <ErrorDialog
                open={swpDialogStatus.isCancelSwpErrorOpen}
                content={pauseCancelResponse?.message ?? ""}
                handleClick={() => handleBtnErrorDialog({ type: "SWP" })}
            />

            {/* Switch Mandate Dialog */}
            {mandateSwitchDialog && (
                <SwitchMandate
                    mandateSwitchDialog={mandateSwitchDialog}
                    handleSwitchMandatePopup={handleSwitchMandatePopup}
                    clientCode={(isRMLikeRole(role?.toLowerCase())) ? (props?.clientCode ?? "") : investorClientId}
                    activeRowAmount={activeRowAmount}
                    helperPayloadObj={helperPayloadObj}
                    activeRowMandId={activeRowMandId}
                    selectedMandateId={selectedMandateId}
                    setSelectedMandateId={setSelectedMandateId}
                    handleActiveMandate={handleActiveMandate}
                    mandateSwitchLoader={mandateSwitchLoader}
                    setMandateSwitchLoader={setMandateSwitchLoader}
                    handleCreateMandate={handleCreateMandate}
                    mandateCreationLoading={mandateCreationLoading}
                    setMandateCreationLoading={setMandateCreationLoading}
                />
            )}

            {/* OTP DIALOG START */}
            <Dialog
                open={isOtpDialogOpen}
                onClose={onOtpDialogClose}
                maxWidth="sm"
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        flexDirection: "column",
                        rowGap: "24px"
                    }
                })}
            >
                <Typography
                    component="span"
                    variant="body_600"
                    sx={(theme: Theme) => ({
                        color: theme.palette.primary[500],
                        textAlign: 'center'
                    })}
                >
                    {otpData?.otp_response?.message ?? ""}
                </Typography>
                <OTPForm
                    onSubmit={handleOtpSubmit}
                    onResend={handleOtpResend}
                    otpMessage=""
                    warningMessage=""
                />
            </Dialog>
            {/* OTP DIALOG END */}

            {/* SUCCESS DIALOG START */}
            <Dialog
                onClose={onSuccessDialogClose}
                open={isSuccessDialogOpen}
                maxWidth='md'
                sx={(theme: Theme) => ({
                    '& .MuiPaper-root': {
                        borderRadius: '12px',
                        backgroundColor: theme.palette.common.white,
                        padding: "24px",
                        flexDirection: "column",
                    }
                })}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <SuccessIcon />
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "20px",
                        marginTop: "20px"
                    }}
                >
                    <Typography
                        component="span"
                        variant="body_600"
                        sx={(theme: Theme) => ({
                            color: theme.palette.text.primary,
                            textAlign: "center"
                        })}
                    >
                        The mandate is switched successfully
                    </Typography>
                    <Box sx={{ mt: 0.5, display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <InfoIconOutlined />
                        <Typography
                            component="span"
                            variant="subtitle_500"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                textAlign: "center"
                            })}
                        >
                            {`NOTE : ${isRMLikeRole(role) ? RM_MAND_SWITCH : INV_MAND_SWITCH}`}
                        </Typography>
                    </Box>

                    <Button
                        variant="contained"
                        fullWidth
                        onClick={onSuccessDialogClose}
                        sx={{ padding: '7px', mt: 2 }}
                    >
                        Okay
                    </Button>
                </Box>
            </Dialog>
            {/* SUCCESS DIALOG END */}
        </>
    )
}